import { createField } from "./haz-discuss-info.section";
//import lodash from "lodash";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    data.fields = createField({ props, data, refs, key, isLoading });
};
